
import API_URLS from '../../config/BackendConfig';
import { getToken } from '../../utils/tokenUtils'; // Updated import to get token from 
import { getRequest, postRequest } from '../../config/AxiosConfig';
const apiBaseUrl = API_URLS.CUSTOMER; 

const prodBaseUrl = API_URLS.PROD;

const getAuthHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};




// register mandate for autodebit
export const registerAutoDebitMandate = async (payload, onAfterRequest = () => {}) => {
  try {
    const response = await postRequest({
      url: prodBaseUrl + "w-emandate",   
      data: payload,                         
      headers: getAuthHeaders(),          
      onAfterRequest,
    });

    return response;
  } catch (error) {
    console.error("Error registering Auto Debit Mandate:", error.response?.data || error.message);
    throw error;
  }
};
